const NUMBER_OF_DECIMALS = 2;
const THOUSANDS_LENGTH = 3;

export default function (
  num: number,
  places: number = NUMBER_OF_DECIMALS,
  symbol: string = '&euro; ',
  thousand: string = '.',
  decimal: string = ','
) {
  let number: number|string = num;
  const negative = number < 0 ? '-' : '';
  const i: string = `${parseInt(number = Math.abs(+number || 0).toFixed(places), 10)}`;
  const l = i.length;
  const j = (l > THOUSANDS_LENGTH) ? l % THOUSANDS_LENGTH : 0;
  const iToNum: number = parseInt(i, 10);
  const numberToNum: number = parseFloat(number);

  // eslint-disable-next-line
  const output = symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(numberToNum - iToNum).toFixed(places).slice(2) : "");

  return output;
}
